<td>
    <ng-template #fieldComponent></ng-template>
</td>